import { AddressDetailPlanOutDTO, BasicContactPerson, ContactPerson } from '@api/ringil-api.v2';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import Address from '@components/obsolete/Address/Address.tsx';
import LoadInfoItem from '@components/obsolete/LoadDetails/LoadInfo/LoadInfoItem.tsx';
import CheckboxWithLabel from '@components/obsolete/CheckboxWithLabel/CheckboxWithLabel.tsx';
import HorizontalFieldValue from '@components/obsolete/HorizontalFieldValue.tsx';
import Label from '@components/obsolete/Form/Label/Label.tsx';
import COTimezone from '@components/FigmaComponents/COTimezone.tsx';
import InfoNote from '@components/obsolete/InfoNote/InfoNote.tsx';

export interface LocationDetail {
  name: string;
  address: AddressDetailPlanOutDTO;
  pickupCode?: string;
  contactName?: string;
  contactPhone?: string;
  contactEmail?: string;
  enabledEmailNotificationForContactPerson: boolean;
  additionalNotificationContacts: BasicContactPerson[];
  timezoneId?: string;
}

interface ContactInfoProps {
  location: LocationDetail;
}

export const ExpeditionContactInfo: React.FC<ContactInfoProps> = ({ location }) => {
  const { t }: { t: any } = useTranslation('common');
  const { tr } = useTranslationLgs();
  return (
    <div className="p-grid row-accordion-info">
      <div className="p-col-12 p-md-5 p-lg-6">
        <div className="p-d-flex">
          <div className="icon-accordion">
            <img src="/images/contacts.svg" alt="" />
          </div>
          <div>
            <Label title={t('expeditionOverviewPage.labelContacts')} />
            {location.pickupCode && (
              <div className="p-mt-2">
                <InfoNote
                  text={t(`LoadInfoItem.codeRef`, `Kód pro dopravce: {{codeRef}}`, {
                    codeRef: location.pickupCode,
                  })}
                />
              </div>
            )}
            <Address company={`${location.name}, ${location.address.city}`} address={`${location.address.streetNr}, ${location.address.zipCode}`} />
            <COTimezone timezoneId={location.timezoneId} />
            <LoadInfoItem name={location.contactName} phone={location.contactPhone} email={location.contactEmail} className="p-mb-3"></LoadInfoItem>
            <CheckboxWithLabel
              checkboxLabel={tr(`ExpeditionContactInfo.sendNotification`, `Send notification`)}
              value={location.enabledEmailNotificationForContactPerson}
              onChange={() => {}}
              disabled={true}
            />
            {location.additionalNotificationContacts && (
              <HorizontalFieldValue
                label={tr('ExpeditionContactInfo.additionalNotifiedPersons', 'Additional notified persons')}
                value={location.additionalNotificationContacts.map((contact, contactIndex) => (
                  <LoadInfoItem key={contactIndex} name={contact.contactName} phone={contact.contactPhone} email={contact.contactEmail} className="p-mb-3"></LoadInfoItem>
                ))}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
